<template>
    <div>
        <b-card class="order-request mb-2" no-body v-if="mode == 'match'">
            <template v-slot:header>
                <div class="d-flex justify-content-between align-items-start">
                    <h5 class="card-title" v-if="clientOrderRequestId != null">Order Request</h5>
                    <h5 class="card-title" v-if="quoteId != null">Estimate</h5>
                    <b-button-toolbar aria-label="Action Buttons">
                        <b-button variant="outline-secondary" size="sm" :href="$urlHelper.getPageUrl('OrderRequests/Edit', [clientOrderRequestId])" class="mr-2" target="_blank" v-if="clientOrderRequestId">Open Request</b-button>
                        <b-button variant="outline-secondary" size="sm" :href="$urlHelper.getPageUrl('Estimates', [quoteId])" class="mr-2" target="_blank" v-if="quoteId">Open Estimate</b-button>
                        <b-button variant="outline-secondary" size="sm" @click="orderRequestDetailsVisible = !orderRequestDetailsVisible"><i :class="orderRequestDetailsVisible ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i></b-button>
                    </b-button-toolbar>

                </div>

                <validation-provider rules="required" v-slot="vp" slim
                                     :custom-messages="{
                                 required: 'The Order Request has to be matched against a matter',
                                 }">
                    <input type="hidden" :value="currentValue" />
                    <b-form-invalid-feedback :state="vp.errors[0] ? false : null">{{ vp.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>
            </template>
            <b-collapse class="card-body" v-model="orderRequestDetailsVisible">
                <b-form-row>
                    <b-form-group :label="$t('Entities.Shared.MatterNumber')"
                                  label-for="clientMatterNumber"
                                  class="col-md-4">
                        <b-form-input name="clientMatterNumber"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedMatterNumber">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Entities.Shared.MatterName')"
                                  label-for="clientMatterName"
                                  class="col-md-4">
                        <b-form-input name="clientMatterName"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedMatterName">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="Jurisdiction"
                                  label-for="courtJurisdiction"
                                  class="col-md-4">
                        <b-form-input name="courtJurisdiction"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedCourtJurisdictionName">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group label="Presiding Officers"
                                  label-for="courtJudges"
                                  class="col-md-8">
                        <b-form-input name="courtJudges"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedCourtJudgeNamesString">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group label="Sitting Date"
                                  label-for="courtSittingDate"
                                  class="col-md-4">
                        <b-form-input name="courtSittingDate"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedCourtSittingDatesString">
                        </b-form-input>
                    </b-form-group>

                    <b-form-group label="Requested Court Room"
                                  label-for="requestedCourtRoomOther"
                                  v-if="requestedCourtRoomOther != null"
                                  class="col-md-4 ">
                        <b-form-input name="requestedCourtRoomOther"
                                      size="sm"
                                      :disabled="true"
                                      :value="requestedCourtRoomOther"
                                      class="text-danger">
                        </b-form-input>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="" class="">
                        <b-button class="align-bottom" variant="success" @click="matchCourtMatterDialogOpen = true" v-if="!disabled" size="sm">
                            <i class="fas fa-search mr-1"></i>Match
                        </b-button>
                    </b-form-group>

                </b-form-row>
            </b-collapse>

        </b-card>

        <b-modal size="xl"
                 title="Match Order Request"
                 v-model="matchCourtMatterDialogOpen"
                 class="mt-0 pt-0 border border-danger"
                 @shown="onModalShown">

            <b-container class="pl-3 pr-3 mt-0 mb-0 w-100" style="max-width:1300px;">

                <b-row class="border-dark border-white" style="background-color:#ccc;">

                    <b-col cols="2" class="border-right border-white pt-2 pb-1"><b-form-checkbox size="lg" checked class="text-center" @input="matchMatters" v-model="includeMatterNumberInMatch">Number</b-form-checkbox></b-col>
                    <b-col cols="3" class="border-right border-white pt-2 pb-1"><b-form-checkbox size="lg" checked class="text-center" @input="matchMatters" v-model="includeMatterNameInMatch">Name</b-form-checkbox></b-col>
                    <b-col cols="3" class="border-right border-white pt-2 pb-1"><b-form-checkbox size="lg" checked class="text-center" @input="matchMatters" v-model="includeCourtJurisdictionInMatch">Jurisdiction</b-form-checkbox></b-col>
                    <b-col cols="2" class=""><b-form-checkbox size="lg" checked class="text-center pt-2 pb-1" @input="matchMatters" v-model="includeCourtSittingDateInMatch">Date</b-form-checkbox></b-col>
                    <b-col cols="1" class="border-right border-white pt-2 pb-1">+/- days</b-col>
                </b-row>

                <b-row class="" style="background-color:#ccc;">

                    <b-col cols="2" class="border-right border-white"><b-input size="sm" @input="matchMatters('matterNumber')" v-model="matterNumberToMatch" /></b-col>
                    <b-col cols="3" class="border-right border-white"><b-input size="sm" @input="matchMatters('matterName')" v-model="matterNameToMatch" /></b-col>
                    <b-col cols="3" class="border-right border-white">

                        <b-form-group v-if="allCourtJurisdictionsForRegistry"
                                      label=""
                                      label-for="courtJurisdictionId">
                            <select2 name="courtJurisdictionId"
                                     :options="allCourtJurisdictionsForRegistry"
                                     cssClass="form-control-sm"
                                     key-property="courtJurisdictionId"
                                     text-property="name"
                                     v-model="courtJurisdictionIdToMatch"
                                     @change="matchMatters">
                            </select2>
                        </b-form-group>

                        <!--  <b-input size="sm" v-model="requestedCourtJurisdictionName" /> -->

                    </b-col>

                    <b-col cols="2" class=""><b-input size="sm" :value="formatDateTime(requestedFirstCourtSittingDate, 'DD/MM/YYYY', true, true)" disabled /></b-col>
                    <b-col cols="1" class="border-right border-white"><b-form-input type="number" min="1" max="7" @keydown.native="enforceValidDayPadding" @input="matchMatters" v-model="courtSittingDateOffsetToMatch" size="sm"></b-form-input></b-col>
                </b-row>

                <b-row v-for="(matter,index) in matchingMatters" class="" v-bind:key="index" style="font-size:14px;">
                    <b-col cols="2" class="border-left border-bottom align-baseline pt-1">{{ matter.matterNumber }}</b-col>
                    <b-col cols="3" class="border-left border-bottom align-baseline pt-1">{{ matter.matterName }} </b-col>
                    <b-col cols="3" class="border-left border-bottom align-bottom pt-1">{{ matter.courtJurisdiction }}</b-col>
                    <b-col cols="3" class="border-left border-bottom align-middle pt-1">{{ matter.sittingDate }}</b-col>
                    <b-col cols="1" class="border-left border-bottom border-right align-middle text-center"><b-form-radio v-model="selectedMatterId" name="selectedMatter" :value="matter.matterId"></b-form-radio></b-col>
                </b-row>

                <b-row class="text-info border p-1" v-if="matchingMatters != null && matchingMatters.length==0">
                    -- no matching records found --
                </b-row>
                                
                <b-row class="text-danger border p-1" v-if="showSearchCriteriaHint">
                    Insufficient search criteria. Please search provide at least 3 characters in the Number and/or Name field/s or activate the Date search
                </b-row>

                <b-row class="text-info  border p-1" v-if="numberOfMatchingResults > 25">
                    Search/match returned more than 25 matters - please refine your search if you want less results!
                </b-row>

            </b-container>

            <template #modal-footer>
                <div class="w-100 d-flex">
                    <b-button size="md" variant="secondary" @click="resetMatchValues" class="mr-1">Reset</b-button>
                    <b-button size="md" variant="primary" @click="createNewMatter" class="mr-auto">New Matter</b-button>
                    <b-button size="md" variant="warning" @click="matchMatters" class="ml-auto mr-1">Search</b-button>
                    <b-button size="md" variant="success" @click="confirmMatterSelection" :disabled="selectedMatterId==null" class="">Confirm</b-button>
                </div>
            </template>
        </b-modal>

        <b-form-row class="">
            <validation-provider rules="required" :name="$t('Vue.CourtMatterSelect.Label.Matter')" v-slot="vp" slim v-if="mode == 'select'">
                <b-form-group :label="$t('Vue.CourtMatterSelect.Label.Matter')"
                              :label-for="name"
                              class="col-md-4">
                    <b-input-group>
                        <select2 ref="courtMatterSelect"
                                 :id="id"
                                 :name="name"
                                 :css-class="cssClass"
                                 :state="(courtRegistryId == null) ? null : vp.errors[0] ? false : null"
                                 :disabled="(disabled || (courtRegistryId == null))"
                                 :placeholder="placeholder"
                                 :options="courtMatters"
                                 enable-ajax
                                 :min-search-chars="2"
                                 search-hint="Enter 2 or more characters to start searching. Start with a # to search by Epiq Reference only."
                                 key-property="courtMatterId"
                                 text-property="displayName"
                                 v-model="currentValue"
                                 v-on:search="findMatters"
                                 v-on:select="matterSelectionChanged"></select2>
                        <b-input-group-append>
                            <b-button variant="outline-secondary"
                                      v-b-tooltip :title="(disabledEditMatterDetails || !(currentSelectedMatter && currentSelectedMatter.courtMatterId)) ? 'Matter details can no longer be edited' : 'Edit Matter Details'"
                                      :disabled="disabledEditMatterDetails || !(currentSelectedMatter && currentSelectedMatter.courtMatterId)"
                                      v-on:click="editCourtMatter">
                                <i class="fas fa-edit"></i>
                            </b-button>

                            <b-button variant="outline-secondary"
                                      title="Glossary"
                                      :href="$urlHelper.getPageUrl('ElectronicGlossary', [currentValue])"
                                      target="_blank"
                                      v-if="!isUuidNullOrEmpty(currentValue)">
                                <i class="fas fa-book mr-1"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="(courtRegistryId == null) ? null : vp.errors[0] ? false : null">{{ vp.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>


            <court-matter-details ref="courtMatterDetails"
                                  :api-url="$urlHelper.apiBaseUrl"
                                  :court-matter-id="currentValue"
                                  css-class="col"
                                  v-if="currentValue"
                                  :details="mode == 'select' ? 'min' : 'med'">
            </court-matter-details>
        </b-form-row>

        <validation-observer v-slot="{ passes }" slim>
            <b-modal size="lg"
                     centered
                     :title="$t('Vue.CourtMatterSelect.CourtMatterDialog.Title')"
                     v-model="editCourtMatterDialogOpen"
                     v-on:shown="editCourtMatterDialogShown"
                     v-on:ok.prevent="passes(createOrUpdateCourtMatter)"
                     v-on:hidden="editCourtMatterDialogHidden">
                <b-alert v-model="showErrors" variant="danger" dismissible>
                    <div v-for="(error, index) in currentErrors" :key="index">
                        <p>{{ error }}</p>
                    </div>
                </b-alert>
                
                <b-alert :show="((relatedOrdersText != '')  && editMatterAllowed)"
                         dismissible
                         variant="warning">
                    {{ relatedOrdersText }}
                </b-alert>

                <b-form-row>
                    <validation-provider rules="required" :name="$t('Entities.Shared.MatterNumber')" v-slot="{ valid, errors }" slim>
                        <b-form-group :label="$t('Entities.Shared.MatterNumber')"
                                      label-for="courtMatterNumber"
                                      class="col-md-4">
                            <b-form-input name="courtMatterNumber"
                                          v-model="currentCourtMatter.matterNumber"
                                          :state="errors[0] ? false : null"
                                          :disabled="!editMatterAllowed"
                                          autofocus>
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider rules="required" :name="$t('Entities.Shared.MatterName')" v-slot="{ valid, errors }" slim>
                        <b-form-group :label="$t('Entities.Shared.MatterName')"
                                      label-for="courtMatterName"
                                      class="col-md-8">
                            <b-form-input name="courtMatterName"
                                          v-model="currentCourtMatter.matterName"
                                          :state="errors[0] ? false : null"
                                          :disabled="!editMatterAllowed">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider rules="required" name="Jurisdiction" v-slot="{ valid, errors }" slim>
                        <b-form-group label="Jurisdiction"
                                      label-for="courtMatterJurisdiction"
                                      class="col-md-4">
                            <select2 name="courtMatterJurisdiction"
                                     placeholder="Select a jurisdiction"
                                     :options="initialCourtJurisdictions"
                                     enable-ajax
                                     in-b-modal
                                     key-property="courtJurisdictionId"
                                     text-property="name"
                                     v-model="currentCourtMatter.courtJurisdictionId"
                                     v-on:search="findJurisdictions"
                                     :disabled="!editMatterAllowed"
                                     :state="errors[0] ? false : null">
                            </select2>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);    
    localize('en', en);

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import UuidMixins from '../mixins/UuidMixins';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.component('select2', Select2);

    export default {
        name: 'CourtMatterSelect',
        mixins: [ErrorsMixin, DateTimeMixin, UuidMixins],
        model: {
            event: 'change',
            prop: 'value'
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            courtRegistryId: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            disabledEditMatterDetails: {
                type: Boolean,
                default: false
            },
            cssClass: {
                type: String,
                default: 'form-control'
            },
            mode: {
                type: String,
                default: 'select',
                validator: function (value) {
                    return ['select', 'match'].includes(value)
                }
            },
            clientOrderRequestId: {
                type: String,
                default: null
            },
            orderId: {
                type: String,
                default: null
            },
            quoteId: {
                type: String,
                default: null
            },
            initialCourtMatters: {
                type: Array,
                default: null
            },
            requestedCourtJurisdictionId: {
                type: String,
                default: null
            },
            requestedCourtJurisdictionName: {
                type: String,
                default: null
            },
            requestedMatterNumber: {
                type: String,
                default: null
            },
            requestedMatterName: {
                type: String,
                default: null
            },
            requestedCourtRoomOther: {
                type: String,
                default: null
            },
            requestedCourtJudgeIds: {
                type: Array,
                default: null
            },
            requestedCourtJudgeNames: {
                type: Array,
                default: null
            },
            requestedCourtSittings: {
                type: Array,
                default: null
            },
            value: null
        },
        data: function () {
            return {
                currentValue: this.value,
                orderRequestDetailsVisible: this.currentValue == null,
                courtMatters: this.initialCourtMatters,
                currentSelectedMatter: (this.initialCourtMatters && this.initialCourtMatters.length) ? this.initialCourtMatters[0] : null,
                matchingMatters: null,

                showSearchCriteriaHint: false,
                numberOfMatchingResults: 0,

                selectedMatterId: null,
                includeCourtJurisdictionInMatch: false,
                courtJurisdictionIdToMatch: this.requestedCourtJurisdictionId,
                includeMatterNumberInMatch: false,
                matterNumberToMatch: this.requestedMatterNumber,
                includeMatterNameInMatch: true,
                matterNameToMatch: this.requestedMatterName,
                includeCourtSittingDateInMatch: false,
                courtSittingDateOffsetToMatch: 2,
                matchCourtMatterDialogOpen: false,
                currentCourtMatter: { matterNumber: null, matterName: null, courtJurisdictionId: null },
                currentErrors: [],
                editCourtMatterDialogOpen: false,
                initialCourtJurisdictions: null,
                lastSearchTerm: null,
                allCourtJurisdictionsForRegistry: null,
                relatedOrders: null,
                relatedOrdersText: '',
                editMatterAllowed: true
            }
        },
        watch: {
            courtRegistryId: function () {
                this.courtMatters = null;
                if (this.currentValue != null) {
                    this.currentValue = null;
                    this.currentSelectedMatter = null;
                    this.$emit('change', this.currentValue);
                }
            }
        },
        computed: {
            requestedCourtJudgeNamesString: function () {
                if (this.requestedCourtJudgeNames == null || this.requestedCourtJudgeNames.length == 0) return null;

                let judgesNameString = ''
                this.requestedCourtJudgeNames.forEach((courtJudgeName) => {
                    judgesNameString += ', ' + courtJudgeName;
                });
                judgesNameString = judgesNameString.substring(2);
                return judgesNameString;
            },
            requestedFirstCourtSittingDate: function() {
                if (this.requestedCourtSittings == null || this.requestedCourtSittings.length == 0) return null;
                return this.requestedCourtSittings[0].sittingDate;
            },
            requestedCourtSittingDatesString: function () {
                if (this.requestedCourtSittings == null || this.requestedCourtSittings.length == 0) return null;
                let courtSittingDatesString = '';
                this.requestedCourtSittings.forEach(s => {
                    courtSittingDatesString += ', ' + this.formatDateTime(s.sittingDate, 'DD/MM/YYYY', true, true);
                });
                courtSittingDatesString = courtSittingDatesString.substring(2);
                return courtSittingDatesString;
            },
            placeholder: function () {
                if (this.courtRegistryId == null) {
                    return 'Select a court/tribunal/other first';
                }
                return this.$t('Vue.Shared.Select2Placeholder.CourtMatter');
            },
            showErrors: function () {
                return this.currentErrors.length > 0;
            }
        },
        methods: {
            onModalShown: function () {
                this.loadCourtJurisdictionsForRegistry();
                this.resetMatchValues();
            },

            enforceValidDayPadding(event) {

                // this method ensures that date day padding is 0 to 7 max
                event.preventDefault();
                const padding = parseInt(event.key, 10);
                if (!isNaN(padding) && padding >= 1 && padding <= 7) {
                    this.courtSittingDateOffsetToMatch = padding;
                } else {
                    this.courtSittingDateOffsetToMatch = ''; 
                }
            },

            checkRelatedOrders: function () {
                var countRelatedOrders = 0;
                
                if (this.relatedOrders) {
                    this.relatedOrders.forEach(relatedOrder => {
                        if (relatedOrder.orderId != this.orderId) {
                            countRelatedOrders++;
                        }
                        if (!relatedOrder.matterModificationAllowed) {
                            this.editMatterAllowed = false;
                        }
                    });
                }

                var allRelatedOrders = '';
                if (countRelatedOrders > 0)
                    allRelatedOrders = 'Warning: Any changes to these matter details will affect ' + countRelatedOrders + ' other order';
                if (countRelatedOrders > 1)
                    allRelatedOrders += 's';

                this.relatedOrdersText = allRelatedOrders;
            },
            loadCourtJurisdictionsForRegistry: function () {

                if (this.courtRegistryId) {
                    var url = this.$urlHelper.getApiUrl('courtjurisdiction', 'bycourtregistries');
                    axios
                        .post(url, [this.courtRegistryId])
                        .then(response => {
                            this.allCourtJurisdictionsForRegistry = response.data;

                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },
            loadRelatedOrders: function () {
                if (this.currentSelectedMatter) {
                    if (this.currentSelectedMatter.courtMatterId) {
                        axios
                            .get(this.$urlHelper.getApiUrl('courtmatter', 'relatedorders', [this.currentSelectedMatter.courtMatterId]))
                            .then(response => {
                                this.relatedOrders = response.data;
                                this.checkRelatedOrders();
                            })
                            .catch(ex => {
                                var currentErrors = this.handleAxiosException(ex);
                                this.showErrorsToast(currentErrors);
                            });
                    }
                }
            },

            resetMatchValues: function () {
                this.includeCourtJurisdictionInMatch = false;
                this.courtJurisdictionIdToMatch = this.requestedCourtJurisdictionId;
                this.includeMatterNumberInMatch = false;
                this.matterNumberToMatch = this.requestedMatterNumber;
                this.includeMatterNameInMatch = true;
                this.matterNameToMatch = this.requestedMatterName;
                this.includeCourtSittingDateInMatch = false;
                this.courtSittingDateOffsetToMatch = 2;
                this.selectedMatterId = null;
                this.matchMatters();
            },

            minimumFilterCriteriaPesent: function (filter) {

                const numberValid = filter.matterNumber?.trim().length >= 3;
                const nameValid = filter.matterName?.trim().length >= 3;
                const dateValid = filter.sittingDate != null;

                // get each columns validity
                const matterNumberValid = this.includeMatterNumberInMatch && numberValid;
                const matterNameValid = this.includeMatterNameInMatch && nameValid;

                // Ensure all conditions are valid, based on the user's inclusions
                if (matterNumberValid || matterNameValid || dateValid) {
                    return true;
                }

                return false;
            },

            matchMatters: function (source = null) {

                if (source == 'matterName' && !this.includeMatterNameInMatch) return;
                if (source == 'matterNumber' && !this.includeMatterNumberInMatch) return;
                
                var filter =
                {
                    courtRegistryId: this.courtRegistryId,
                    courtJurisdictionId: (this.includeCourtJurisdictionInMatch) ? this.courtJurisdictionIdToMatch : null,
                    matterNumber: (this.includeMatterNumberInMatch) ? this.matterNumberToMatch : null, 
                    matterName: (this.includeMatterNameInMatch) ? this.matterNameToMatch : null,
                    sittingDate: (this.includeCourtSittingDateInMatch) ? this.requestedFirstCourtSittingDate : null,
                    sittingDateOffset: this.courtSittingDateOffsetToMatch,
                }
                console.log('Filter constellation: ' + JSON.stringify(filter));

                if (this.minimumFilterCriteriaPesent(filter)) {

                    console.log('Axios loading data ...');

                    this.showSearchCriteriaHint = false;
                    this.numberOfMatchingResults = 0;

                    var url = this.$urlHelper.getApiUrl('courtmatter', 'findbyfilter');
                    axios
                        .post(url, filter)
                        .then(response => {
                            //this.matchingMatters = response.data;
                            this.numberOfMatchingResults = response.data.length;

                            console.log('     Loaded: ' + this.numberOfMatchingResults);

                            // add 25 out of possible 26 results to the matching matters array
                            this.matchingMatters = response.data.slice(0, 25);
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                } else {
                    this.matchingMatters = [];
                    this.showSearchCriteriaHint = true;
                }

            },

            confirmMatterSelection: function () {
                this.currentValue = this.selectedMatterId;
                this.matchCourtMatterDialogOpen = false;
                this.$emit('change', this.currentValue);
            },
            createNewMatter: function () {

                this.matchCourtMatterDialogOpen = false;
                this.currentCourtMatter = {
                    matterNumber: this.matterNumberToMatch,
                    matterName: this.matterNameToMatch,
                    courtJurisdictionId: this.requestedCourtJurisdictionId
                };
                this.initialCourtJurisdictions = null;
                if (this.requestedCourtJurisdictionId) {
                    this.initialCourtJurisdictions = [{ courtJurisdictionId: this.requestedCourtJurisdictionId, name: this.requestedCourtJurisdictionName }];
                }
                this.currentErrors = [];
                this.currentSelectedMatter = null;
                this.editCourtMatterDialogOpen = true;
            },

            findMatters: function(params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined")
                    filter.searchTerm = params.data.term;
                var url = this.$urlHelper.getApiUrl('courtmatter', null, [this.courtRegistryId, 'find']);

                this.lastSearchTerm = params.data.term;
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.courtMatterId;
                                obj.text = obj.displayName;
                                return obj;
                            });
                            mappedData[mappedData.length] = { id: '00000000-0000-0000-0000-000000000000', text: 'New Matter' };
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },
            matterSelectionChanged: function () {
                        
                if (this.currentValue == '00000000-0000-0000-0000-000000000000') {
                    this.currentCourtMatter = { matterNumber: null, matterName: this.lastSearchTerm, courtJurisdictionId: null };
                    this.initialCourtJurisdictions = null;
                    this.currentErrors = [];
                    this.currentSelectedMatter = null;
                    this.editCourtMatterDialogOpen = true;
                } else {
                    if (this.currentValue != null) {
                        this.currentSelectedMatter = this.$refs.courtMatterSelect.getSelectedData();
                        if (this.currentSelectedMatter && this.currentSelectedMatter.length) this.currentSelectedMatter = this.currentSelectedMatter[0];
                        this.$emit('change', this.currentValue);
                        this.$emit('court-matter-change');
                        if (this.$refs.courtMatterDetails) this.$refs.courtMatterDetails.reload();
                    }
                    else
                        this.currentSelectedMatter = null;

                }
            },
            findJurisdictions: function(params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined")
                    filter.searchTerm = params.data.term;
                var url = this.$urlHelper.getApiUrl('courtjurisdiction', 'bycourtregistry', [this.courtRegistryId, 'find']);
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.courtJurisdictionId;
                                obj.text = obj.name;
                                return obj;
                            });
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },
            createOrUpdateCourtMatter: function() {
                var data = {
                    courtMatter: this.currentCourtMatter
                };
                if (!data.courtMatter.courtMatterId) {
                    delete data.courtMatter.courtMatterId;
                }
                this.currentErrors = [];
                var url = this.$urlHelper.getApiUrl('courtmatter');
                axios
                    .request(
                        {
                            method: this.currentCourtMatter.courtMatterId ? 'put' : 'post',
                            url: url,
                            data: JSON.stringify(data),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        var courtMatter = response.data;
                        if (this.mode == 'select') {
                            this.$refs.courtMatterSelect.setOptionsAndValue([courtMatter], courtMatter.courtMatterId);
                        }
                        this.currentValue = courtMatter.courtMatterId;
                        if (this.mode != 'select') {
                            this.$emit('change', this.currentValue);
                        }
                    })
                    .catch(ex => {
                        this.currentErrors = this.handleAxiosException(ex);
                    })
                    .finally(() => {
                        if (this.currentErrors.length == 0) {
                            this.editCourtMatterDialogOpen = false;
                        }
                    });
            },
            editCourtMatterDialogShown: function () {
                this.editMatterAllowed = true;
                this.loadRelatedOrders();
            },
            editCourtMatterDialogHidden: function () {
                this.relatedOrdersText = '';
                if (this.currentValue == '00000000-0000-0000-0000-000000000000') {
                    this.currentValue = null;
                }
                if (this.mode == 'select') {
                    this.matterSelectionChanged();
                    this.$refs.courtMatterSelect.focus();
                }
            },
            editCourtMatter: function() {
                this.currentCourtMatter = {
                    courtMatterId: this.currentSelectedMatter.courtMatterId,
                    matterNumber: this.currentSelectedMatter.matterNumber,
                    matterName: this.currentSelectedMatter.matterName,
                    courtJurisdictionId: this.currentSelectedMatter.courtJurisdictionId
                };
                this.initialCourtJurisdictions = [this.currentSelectedMatter.courtJurisdiction];
                this.currentErrors = [];
                this.editCourtMatterDialogOpen = true;
            }
        },

        mounted: function () {
        }
    }
</script>

<style scoped>
    .order-request {
        background-color: #ADD8E6;
        border: 1px solid #aaa;
    }
</style>